import { render, staticRenderFns } from "./Entry_button.vue?vue&type=template&id=2bcd62c3&scoped=true"
import script from "./Entry_button.vue?vue&type=script&lang=js"
export * from "./Entry_button.vue?vue&type=script&lang=js"
import style0 from "./Entry_button.vue?vue&type=style&index=0&id=2bcd62c3&prod&lng=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd62c3",
  null
  
)

export default component.exports